var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("home-layout", {
    scopedSlots: _vm._u([
      {
        key: "products",
        fn: function() {
          return [
            _c("CustomSearchTitleArea"),
            _vm._v(" "),
            _c("CustomProductsSelector", {
              model: {
                value: _vm.product,
                callback: function($$v) {
                  _vm.product = $$v
                },
                expression: "product"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "px-3 px-md-5 py-0" },
              [
                _vm.isProductVoloHotel
                  ? _c("VoloHotelSearchForm", {
                      on: { change: _vm.setSearchType }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProductTour
                  ? _c("TourAccompagnatoSearchForm", {
                      on: { change: _vm.setSearchType }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProductExperience
                  ? _c("ExperienceSearchForm", {
                      on: { change: _vm.setSearchType }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "p-3 p-md-5" },
              [_vm.isProductVoloHotel ? _c("OfferteSpeciali") : _vm._e()],
              1
            ),
            _vm._v(" "),
            _vm.hasTours
              ? _c(
                  "div",
                  { staticClass: "prossimi-tour-area py-5 bg-white" },
                  [
                    _vm.isMobile
                      ? _c("ProssimiTourMobile", {
                          attrs: {
                            title: "Non vedi l'ora di partire?",
                            subtitle: "scopri i prossimi tour in partenza"
                          }
                        })
                      : _c("ProssimiTour", {
                          attrs: {
                            title: "Non vedi l'ora di partire?",
                            subtitle: "scopri i prossimi tour in partenza"
                          }
                        })
                  ],
                  1
                )
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "content-footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "gray-area py-5" },
              [_c("CustomStaticsArea", { staticClass: "container" })],
              1
            ),
            _vm._v(" "),
            _c("CustomSelectionMap", { staticClass: "py-5" }),
            _vm._v(" "),
            _c("CustomParallaxArea"),
            _vm._v(" "),
            _c("ScrollToTop")
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18c319d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18c319d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/pages/Home.vue
// module id = null
// module chunks = 